let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("23cyj")).then(() => parcelRequire('9J2Ud'));